import {tabbedProductDetailsTest} from '../constants/signalmanConstants';

export const isTabbedProductDetailsTestEnabled = () => {
  return tabbedProductDetailsTest === 'test';
};

export const fireTabbedProductDetailsAnalytics = () => {
  window.dataLayer.push({
    ab_test_group: tabbedProductDetailsTest,
    ab_test_location: 'pdp catalog',
    ab_test_name: '2025 10 01 tabbed product details',
    event: 'ab_test_group'
  });
};

export const desktopTabbedProductDetailsAnalytics = (clickedTabName) => {
  window.dataLayer.push({
    event: 'pdp_interaction',
    interaction_action: clickedTabName, // click details, click delivery, click description
    interaction_label: 'product details'
  });
};

export const mobileAccordionAnalytics = (
  clickedAccordionName,
  interactionValue
) => {
  window.dataLayer.push({
    event: 'pdp_interaction',
    interaction_action: clickedAccordionName, // click details, click delivery, click description
    interaction_label: 'product details',
    interaction_value: interactionValue // expand, collapse
  });
};
